// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-9ba5177a]::-webkit-outer-spin-button,\ninput[data-v-9ba5177a]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-9ba5177a] {\n  -moz-appearance: textfield;\n}\n.reassignment-card[data-v-9ba5177a] {\n  word-break: normal;\n  overflow-wrap: break-word;\n}\n[data-v-9ba5177a] p {\n  word-break: normal;\n}", ""]);
// Exports
module.exports = exports;
